import { render } from "./openGroup.vue?vue&type=template&id=587605f5&scoped=true"
import script from "./openGroup.vue?vue&type=script&lang=js"
export * from "./openGroup.vue?vue&type=script&lang=js"

import "./openGroup.vue?vue&type=style&index=0&id=587605f5&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587605f5"]])

export default __exports__